import React from 'react';

import styles from './Discourse.module.scss';

const DiscourseLoading = () => {
  return (
    <h3 className={styles.loading}>Loading</h3>
  );
};

export default DiscourseLoading;
